import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
export function PurchaseToast() {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const timeout = window.setTimeout(() => setVisible(false), 10000);
    return () => window.clearTimeout(timeout);
  }, []);
  return <AnimatePresence data-id="element-30">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 22
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 22
    }} transition={{
      duration: 0.25
    }} aria-live="polite" className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] rounded-xl border border-[#e1c9bc] bg-[#fff9f2] p-3 pr-10 shadow-xl sm:bottom-6 sm:left-6" data-id="element-31">
          <CheckCircle2Icon className="absolute left-3 top-3.5 h-4 w-4 text-[#8d2f50]" aria-hidden="true" data-id="element-32" />
          <p className="pl-6 text-[10px] font-extrabold uppercase tracking-[0.14em] text-[#9d3659]" data-id="element-33">
            Compra verificada
          </p>
          <p className="mt-1 pl-6 text-xs text-[#4b2735]" data-id="element-34">
            <strong data-id="element-35">Valentina M.</strong> de Ciudad de México eligió MegaPack +
            Diario
          </p>
          <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded p-1 text-[#866a73] hover:text-[#381421] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#7b2948]" data-id="element-36">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" />
          </button>
        </motion.aside>}
    </AnimatePresence>;
}